import React from 'react';
import { useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations/flags/featureFlags';
import { CHAT_SERVICE_MODE } from 'modules/taboola-common-frontend-modules/chat-agent/config/chatServiceMode';
import { useChatAgentContext } from 'modules/taboola-common-frontend-modules/chat-agent/hooks/useChatAgentContext';
import { ChatAgentContainer } from '../ChatAgentContainer/ChatAgentContainer';
import { ChatKitContainer } from '../ChatKitContainer/ChatKitContainer';

export const ChatAgentSidebarChatContainer = ({ chatContainerRef, chatKitContainerRef, closeChat }) => {
    const { chatServiceMode } = useChatAgentContext();
    const isChatKitEnabled = useConfigMatch({ [FEATURE_FLAGS.CHAT_KIT_ENABLED]: 'true' });
    const isChatKitServiceMode = chatServiceMode === CHAT_SERVICE_MODE.CHATKIT && isChatKitEnabled;

    return (
        <>
            <ChatKitContainer
                chatKitContainerRef={chatKitContainerRef}
                isHidden={!isChatKitServiceMode}
                closeChat={closeChat}
            />
            <ChatAgentContainer
                chatContainerRef={chatContainerRef}
                isHidden={isChatKitServiceMode}
                closeChat={closeChat}
            />
        </>
    );
};
